import { useQuery } from '@tanstack/react-query';
import { GET, GET_POLICIES } from '../../../../services';

export const useGetPolicies = () =>
  useQuery({
    queryKey: ['policiesQuery'],
    queryFn: async () => {
      const response = await GET(GET_POLICIES());
      return response.result.item.policyText;
    },
  });
